import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import RouteDebug from '../common/RouteDebug';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto p-4 md:p-6 flex flex-col" role="main" aria-label="Main content">
          <div className="flex-1">{children}</div>
          <footer className="text-center text-xs text-gray-400 py-3 mt-4">
            Powered by{' '}
            <a href="https://azmoris.io" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-700">
              AZMORIS Group
            </a>
          </footer>
        </main>
      </div>
    </div>
  );
};

export default Layout;
